var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="row">\n  <div class="col-md-9" data-mount="name">\n    ';
 if (readOnly) { 
__p+='\n      <div class="keyword-item-readonly">'+
((__t=( model.get("name") ))==null?'':__t)+
'</div>\n    ';
 } else { 
__p+='\n      <input type="text" value="" placeholder="Enter one or more words" class="form-control" />\n    ';
 } 
__p+='\n  </div>\n\n  <div class="col-3 spoken-by">\n    ';
 if (readOnly) { 
__p+='\n      <div class="keyword-item-readonly">'+
((__t=( model.get("speaker") ))==null?'':__t)+
'</div>\n    ';
 } else { 
__p+='\n      <select data-plugin="select2" data-select2-attr-name="spoken_by">\n        <option>Agent</option>\n        <option>Caller</option>\n        <option>Agent or Caller</option>\n      </select>\n    ';
 } 
__p+='\n   </div>\n</div>\n';
}
return __p;
};
